'use strict';

const geScriptsBase = require('./../../../../../../../richemont/cartridges/int_globale_custom/cartridge/client/default/js/geScriptLoader');
const { isEmpty, get } = require('lodash');
const { GeScriptLoader, Helpers } = geScriptsBase;

//--------------------------------------------------
// Initialisation
//--------------------------------------------------

/**
 * General init function
 */
function init() {
    var geScriptLoader = new GeScriptLoader();
    geScriptLoader.init();
}

Helpers.injectDatalayer = async (url, body) => {
    const response = await Helpers.makeJsonAjaxCall(url, 'POST', body);

    let analyticsResponse = {};
    try {
        analyticsResponse = JSON.parse(response);
    } catch (error) {
        analyticsResponse = {};
    }

    const datalayer = get(analyticsResponse, 'datalayer', []);
    if (!isEmpty(datalayer)) {
        window.dataLayer = [...window.dataLayer, ...datalayer];
    }
};

GeScriptLoader.prototype.onCheckoutStepLoadedHandler = async function (data) {
    try {
        if (data.StepId === data.Steps.CONFIRMATION) {
            // stop sending keepAlive ajax call
            if ('globaleKeepAlive' in window && window.globaleKeepAlive) {
                clearInterval(window.globaleKeepAlive);
            }
        }

        const geIframe = document.querySelector('#gle_iframe');
        await Helpers.injectDatalayer(geIframe.dataset.analyticsUrl, JSON.stringify(data));
    } catch (e) {
        console.error(e); // eslint-disable-line no-console
    }
};

/**
 * Run initialisation once document is loaded
 */
if (/complete|interactive|loaded/.test(document.readyState)) {
    init();
} else {
    document.addEventListener('DOMContentLoaded', init);
}
